

function loadImg(url, callback) {
    var img = document.createElement("img");
    img.setAttribute("crossOrigin",'Anonymous');
    img.src = url;
    img.onload = function () {
        callback && callback(img);
    };
}

function isIOS() {
    return navigator.userAgent.match(/iphone/i);
}

function param(search, name, defaultValue) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = search.substr(1).match(reg);
    return r ? decodeURIComponent(r[2]) : defaultValue;
}

function loopQuery(sel, callback) {
    let arrd;
    if(typeof(sel)==="string")
    {
        arrd = document.querySelectorAll(sel);
    }
    else
    {
        arrd = sel;
    }
    for(let i=0;i<arrd.length;i++)
    {
       var e = arrd[i];
       callback.call(e, e, i, arrd);
    }
}



function getFileName(path) {
    let n = path.lastIndexOf("/");
    return path.substr(n+1);
}

export {loadImg, isIOS, param, loopQuery, getFileName};


export function isOutNet() {
    let hostname = location.hostname;
    if(hostname.startsWith("192.168.")) return false;
    if(hostname === "127.0.0.1") return false;
    if(hostname === "localhost") return false;
    return true;
}



export function getY(y1, y2) {
    const hBw6 = 1.608;
    const hBwX_d = 1.9516908212560387 - hBw6;
    const ele = document.documentElement;
    const x = ele.clientWidthh/ele.clientHeight;
    return (y2 - y1)/hBwX_d*(x - hBw6) + y1;
}




// export let debug = false;
// debugDebug();
// function debugDebug() {
//     debug = true;
// }

export function distSquare(p1, p2) {
    let dx = p1.x - p2.x;
    let dy = p1.y - p2.y;
    return dx*dx + dy*dy;
}

export  function dist(p1, p2) {
    return Math.sqrt(distSquare(p1,p2));
}